import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalDevelopmentsService } from "services/ClientPortalDevelopmentsService";
import { ClientPortalDevelopmentInfoModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type DevelopmentInfoState = {
  Loading: boolean;
  Developments: ClientPortalDevelopmentInfoModel[] | undefined;
  CanLoadMore: boolean;
};

const initialState: DevelopmentInfoState = {
  Loading: false,
  Developments: undefined,
  CanLoadMore: false,
};

const developmentInfoSlice = createSlice({
  name: "developmentinfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDevelopmentContacts.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getDevelopmentContacts.fulfilled, (state, action) => {
        if (state.Developments == undefined) {
          state.Developments = action.payload;
        } else {
          state.Developments = action.payload;
        }

        if (action.payload.length < 10) {
          state.CanLoadMore = false;
        }

        state.Loading = false;
      })
      .addCase(getDevelopmentContacts.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const getDevelopmentContacts = createAsyncThunk<
  ClientPortalDevelopmentInfoModel[],
  { index: number | undefined; pageSize: number | undefined }
>("DevelopmentInfo/GetDevelopmentContacts", async ({ index, pageSize }) => {
  const developmentsService = container.get<IClientPortalDevelopmentsService>(
    SERVICE_TYPES.CPLClientPortalDevelopmentsClient
  );
  return await developmentsService.getContacts(index, pageSize);
});

export const selectDevelopments = (state: RootState) => state.developmentInfo.Developments;
export const selectLoading = (state: RootState) => state.developmentInfo.Loading;
export const selectCanLoadMore = (state: RootState) => state.developmentInfo.CanLoadMore;

export default developmentInfoSlice.reducer;
